<template lang="html">
    <div class="d-flex flex-column" v-if="content != null">
        <div class="d-flex flex-row align-items-center">
            <div class="row g-0 align-self-center align-items-center justify-content-center">
                <div class="cta-3 text-primary">Publication automatique </div>
            </div>


            <button  @click="delete_state()" type="button" class="btn btn-outline-primary btn-sm btn-icon btn-icon-only ms-auto" ><i class="bi-trash"></i></button>
        </div>

        <div class="text-alternate">{{ human_created_on }}</div>

        <div class="align-items-center mt-2" :class="get_status_text(s, index)"  v-for="(s, index) in this.context.data.Status">
            <i class="d-inline-block icon-16 me-2 " :class="get_status_icon(s, index)"></i>
            <span>&nbsp;</span><span>{{context.data.POSSIBLE_STATUS[s.key].verbose_name}}</span><span>&nbsp;</span><span>{{s.on|from_now}}</span>
            <div style="padding-left:18px;font-size:12px;color:#555;">{{s.info}}</div>
        </div>
    </div>
</template>

<script>
import tools from "@/tools.js";
import settings from "@/settings.coffee";

export default {
  name: "StratalisPublication",
  props: {
    context: {
      type: Object,
      required: true
    },
    review: {
      type: Object,
      required: true
    },
    human_created_on: String
  },
  data() {
    return {
      content: { uid: "0" },
      success_img_path: require("@/assets/success_" + String(this.context.uid[0]) + ".gif")
    };
  },
  methods: {
    get_link(state, data) {
      let ret = null;
      if (this.$store.state.profile.is_superuser) {
        if (["stratalis_pending", "stratalis_failed", "stratalis_done"].indexOf(state.key) >= 0) {
          ret = settings.backendUrl + "/admin/stratalis_job_info/" + data.job_uuid;
        }
        if (["request_sent", "request_rejected"].indexOf(state.key) >= 0 && data.StratalisRequest_pk) {
          ret = settings.backendUrl + "/admin/stratalis_api/stratalisrequest/" + data.StratalisRequest_pk;
        }
      }
      return ret;
    },
    get_status_icon(s, index) {
      let ret = "";
      if (index === this.context.data.Status.length - 1) {
        ret = "bi-record-circle has-text-warning";
      } else if (index < this.context.data.Status.length - 1) {
        ret = "bi-check-circle has-text-success";
      }
      if (s.key === "request_rejected" || s.key === "request_failed" || s.key === "stratalis_failed") {
        ret = "bi-stopwatch has-text-danger";
      }
      if (s.key === "stratalis_done") {
        ret = "bi-check-circle has-text-success";
      }
      return ret;
    },
    get_status_text(s, index) {
      let ret = "";
      if (index === this.context.data.Status.length - 1) {
        ret = "has-text-warning";
      } else if (index < this.context.data.Status.length - 1) {
        ret = "has-text-success";
      }
      if (s.key === "request_rejected" || s.key === "request_failed" || s.key === "stratalis_failed") {
        ret = "has-text-danger";
      }
      if (s.key === "stratalis_done") {
        ret = "has-text-success";
      }
      return ret;
    },
    getTextFromReview(review, fr) {
      let ret = "";
      for (let i = 0; i < review.state_set.length; i++) {
        const r = review.state_set[i];
        if (r.class_name === "AnswerAccepted") {
          if (fr) {
            ret = r.data.answer.text_fr;
          } else {
            ret = r.data.answer.text_native;
          }
        }
      }
      return ret;
    },
    random_number() {
      return String(Math.floor(Math.random() * 10));
    },
    copy(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      this.$store.dispatch("notify", {
        level: "success",
        text: "Copié!",
        seconds: 2
      });
    },
    delete_state() {
      this.$emit("state:delete_state");
    }
  },
  mounted() {
    // rien à faire ici
  },
  created() {
    this.content = tools.deep_copy(this.context);
  }
};
</script>

<style lang="scss" scoped>
</style>
